
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as healthp7PnHBC0tSpeatOz9vXjGIjKN_teh7mKc1wgt8BlwWEMeta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_93FXG4HlHU_45MCCGs5XeYtdTARurKEWcQmQbDZN9_45DdPncMeta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/packages/base/pages/[...slug].vue?macro=true";
import { default as _91IATA_93uLU0OsvRjbW1uLzJW3z2Zp1ncPAqVjEzAhxk_45k8nhoYMeta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/port-parking/[IATA].vue?macro=true";
import { default as _91IATA_93QRAGkd0tE87udZOElyTTcI_tB0Ov06wOwnMTZsnWMGEMeta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-lounges/[IATA].vue?macro=true";
import { default as _91IATA_93k1epnHzsZagKMSIwWwB9gNN_nfQqWMH_WA26bkba7I0Meta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-parking/[IATA].vue?macro=true";
import { default as _91_46_46_46slug_93WNDPjr872X4zGQ_45Dev9OlbXyxK5PJI9hMmcQY2UHp7gMeta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/subdomain/business/[...slug].vue?macro=true";
import { default as _91IATA_936JKY9WZUm5qpeYTSVN_Cltiyz11cextSzo2UrCRwxxEMeta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-hotels-with-parking/[IATA].vue?macro=true";
import { default as _91product_slug_93XuCIsQrFSiIPVX6J_jwnfvF05qV6Gl4oC0fjpwJuL3wMeta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/port-parking/[location]/[product_slug].vue?macro=true";
import { default as _91product_slug_93MXic0ooNLpMf6h5KPLPz1EDqIr38_u_z8_45eMUXmIf2sMeta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-lounges/[location]/[product_slug].vue?macro=true";
import { default as _91product_slug_93w1cCMFayjrfPSaw1JdbjYfBRJvCWlKWfmSPOkRy0y7oMeta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-parking/[location]/[product_slug].vue?macro=true";
import { default as _91product_slug_93mNtufQ8njQSRplDf0Nomc2VvYxJwmIBC_45_52s0YMPGgMeta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-hotels-with-parking/[location]/[product_slug].vue?macro=true";
import { default as component_45stubiQt4zX3vBKgQPKCiNvCrAXX7rB98Nz1Ls8l_45WxIkOq8Meta } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.2.0_db0@0.3.2_esl_7b971c857bfcbd5bf46044242e35ecc0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubiQt4zX3vBKgQPKCiNvCrAXX7rB98Nz1Ls8l_45WxIkOq8 } from "/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.2.0_db0@0.3.2_esl_7b971c857bfcbd5bf46044242e35ecc0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/packages/base/pages/[...slug].vue")
  },
  {
    name: "port-parking-IATA___en",
    path: "/port-parking/:IATA()",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/port-parking/[IATA].vue")
  },
  {
    name: "airport-lounges-IATA___en",
    path: "/airport-lounges/:IATA()",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-lounges/[IATA].vue")
  },
  {
    name: "airport-parking-IATA___en",
    path: "/airport-parking/:IATA()",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-parking/[IATA].vue")
  },
  {
    name: "subdomain-business-slug___en",
    path: "/subdomain/business/:slug(.*)*",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/subdomain/business/[...slug].vue")
  },
  {
    name: "airport-hotels-with-parking-IATA___en",
    path: "/airport-hotels-with-parking/:IATA()",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-hotels-with-parking/[IATA].vue")
  },
  {
    name: "port-parking-location-product_slug___en",
    path: "/port-parking/:location()/:product_slug()",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/port-parking/[location]/[product_slug].vue")
  },
  {
    name: "airport-lounges-location-product_slug___en",
    path: "/airport-lounges/:location()/:product_slug()",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-lounges/[location]/[product_slug].vue")
  },
  {
    name: "airport-parking-location-product_slug___en",
    path: "/airport-parking/:location()/:product_slug()",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-parking/[location]/[product_slug].vue")
  },
  {
    name: "airport-hotels-with-parking-location-product_slug___en",
    path: "/airport-hotels-with-parking/:location()/:product_slug()",
    component: () => import("/codebuild/output/src4060429532/src/bitbucket.org/magusa/cavu-workspaces/apps/sps/pages/airport-hotels-with-parking/[location]/[product_slug].vue")
  },
  {
    name: component_45stubiQt4zX3vBKgQPKCiNvCrAXX7rB98Nz1Ls8l_45WxIkOq8Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubiQt4zX3vBKgQPKCiNvCrAXX7rB98Nz1Ls8l_45WxIkOq8
  }
]